



















import { Vue, Component, Watch } from 'vue-property-decorator';
import appConfig from '../../appConfig';

// ダイアログ表示を行わない画面（URL）のリスト
// ex) [ '/hoge', '/poyo', '/fuga' ]
const ignoreUrls: string[] = [ '/Help', '/FAQ', '/Terms', '/About1dService', '/OpenSourceLicense', '/ErrorPage' ];

@Component
export default class TermsOfServiceDialog extends Vue {

    private dialog = false;
    private disabled = false;
    private consent = false;

    public setConsentFlag() {
        localStorage.setItem('consent', 'true');
        this.dialog = false;
        this.$store.commit('acceptTerms');
        // Cookieを削除 -> 画面を読み込み直さずに別ページへ遷移の
        // オペレーションをした時にチェックがつきっぱなしになるのに対応。
        this.consent = false;
    }

    public mounted() {
        // 利用規約のHTMLを取得しておく
        const htmlArea = this.$refs.htmlArea as Element;
        if (htmlArea) {
            fetch(this.tosUrl)
                .then((res) => res.text())
                .then((text) => htmlArea.innerHTML = text);
        }

        if (this.shouldShowDialog()) {
            this.dialog = true;
        } else {
            this.$store.commit('acceptTerms');
        }
    }

    // "ignoreUrlsのURL -> 表示すべきURL" の動きの時にダイアログが出るようにするためのwatch
    @Watch('$route.path')
    public onValueChange(newPath: string, oldPath: string): void {
        this.dialog = this.shouldShowDialog();
    }

    private shouldShowDialog(): boolean {
        return !ignoreUrls.find((x) => x === this.$route.path) && !localStorage.getItem('consent');
    }

    get tosUrl(): string {
        return appConfig.tosPageUrl;
    }
}
